import React from "react";
import { RankingFichaDiariaViewProps } from "../types";
import { Header } from "./Header";
import { NavigationButtons } from "../../Producao/components/NavigationButtons";
import { LojaSelector } from "../../Producao/components/LojaSelector";
import { RankingList } from "./RankingList";
import { StatsCard } from "./StatsCard";

export const RankingFichaDiariaView: React.FC<RankingFichaDiariaViewProps> = ({
  usuarios = [],
  dailyStats = {
    itensEncerrados: 0,
    emProducao: 0,
    tempoMedioFormatado: "00:00",
    usuarios: 0,
    producaoKgFormatado: "0",
    producaoPorUnd: [],
  },
  lojas = [],
  selectedLojaId,
  showLojaSelector = false,
  dateLabel,
  selectedLojaNome,
  criterio,
  onGoHome,
  onToggleLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  return (
    <div className="relative flex h-screen flex-col overflow-hidden bg-red-900 text-white">
      <NavigationButtons
        lojasCount={lojas.length}
        onGoHome={onGoHome}
        onToggleLojaSelector={onToggleLojaSelector}
      />

      <LojaSelector
        lojas={lojas}
        selectedLojaId={selectedLojaId}
        showLojaSelector={showLojaSelector}
        onSelectAllLojas={onSelectAllLojas}
        onSelectLoja={onSelectLoja}
      />

      <Header
        dateLabel={dateLabel}
        selectedLojaId={selectedLojaId}
        selectedLojaNome={selectedLojaNome}
        criterio={criterio}
      />

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-3 pb-4 pt-1 sm:px-6">
        <div className="mx-auto flex h-full min-h-0 w-full max-w-7xl flex-1 flex-col overflow-hidden">
          <RankingList usuarios={usuarios} />
          <StatsCard dailyStats={dailyStats} />
        </div>
      </div>
    </div>
  );
};
